(() => {
      function enrichHelpGuideSchema() {
        const payload = document.getElementById('HelpGuideArticleData');
        if (!payload) return;
        const guide = JSON.parse(payload.textContent);
        const rootUrl = new URL(guide.publisher.url);
        const logo = Array.from(document.querySelectorAll('a img')).find(image => {
          const link = image.closest('a');
          try { return new URL(link.getAttribute('href'), rootUrl).href === rootUrl.href; }
          catch { return false; }
        });
        if (logo) {
          const logoUrl = logo.currentSrc || logo.getAttribute('src');
          if (logoUrl) guide.publisher.logo = { '@type': 'ImageObject', url: new URL(logoUrl, rootUrl).href };
        }
        let matched = false;
        document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
          let data;
          try { data = JSON.parse(script.textContent); } catch { return; }
          let changed = false;
          const nodes = Array.isArray(data) ? data : data['@graph'] || [data];
          nodes.forEach(node => {
            if (!node || typeof node !== 'object') return;
            const types = [].concat(node['@type'] || []);
            if (types.includes('Organization') && node.name === guide.publisher.name) {
              node['@id'] = guide.publisher['@id'];
              if (guide.publisher.logo) node.logo = guide.publisher.logo;
              changed = true;
            }
            if (!types.some(type => ['BlogPosting', 'Article', 'NewsArticle'].includes(type))) return;
            const nodeUrl = node.url || (typeof node.mainEntityOfPage === 'string' ? node.mainEntityOfPage : node.mainEntityOfPage?.['@id']);
            if (nodeUrl && new URL(nodeUrl, rootUrl).href !== guide.url) return;
            Object.assign(node, guide);
            if (!guide.author) delete node.author;
            changed = true;
            matched = true;
          });
          if (changed) script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
        });
        if (!matched) {
          const script = document.createElement('script');
          script.type = 'application/ld+json';
          script.id = 'HelpGuideArticleSchema';
          script.textContent = JSON.stringify(guide).replace(/</g, '\\u003c');
          document.head.append(script);
        }
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enrichHelpGuideSchema, { once: true });
      else enrichHelpGuideSchema();
    })();
